export const VALID_ID = /^[a-z-A-Z0-9._-]+$/

export const DRAFTS_DIR = 'drafts'
export const VERSION_DIR = 'versions'

export const PATH_SEPARATOR = '.'
export const DRAFTS_PREFIX = `${DRAFTS_DIR}${PATH_SEPARATOR}`
export const VERSION_PREFIX = `${VERSION_DIR}${PATH_SEPARATOR}`
